const ROUTES = {
  HOME: "/",
  CALCULATOR: "/calculator",
  ABOUT: "/about",
};

export { ROUTES };
